import React, { useEffect } from 'react'

export const HtmlClass: React.FC<{ className: string }> = ({ className }) => {
  useEffect(() => {
    document.querySelector('html')?.classList.add(className)

    return () => {
      document.querySelector('html')?.classList.remove(className)
    }
  }, [className])

  return null
}
